// ----- State -----
// Datos de contacto que el distribuidor rellena desde Account details y que
// acaban en el pie del presupuesto.
const emptyDetails = {
  company: "",
  email: "",
  phone: "",
  website: "",
};

const initialState = {
  name: "",
  details: emptyDetails,
  areDetailsLoaded: false,
};

// ----- Types -----
const DISTRIBUTOR_DETAILS_LOADED = "DISTRIBUTOR_DETAILS_LOADED";
const DISTRIBUTOR_DETAILS_UPDATED = "DISTRIBUTOR_DETAILS_UPDATED";

// La base de datos devuelve null en los campos sin rellenar, y los inputs de
// React necesitan cadena vacia para no volverse no controlados.
const withoutNulls = (details) =>
  Object.keys(emptyDetails).reduce((acc, field) => ({ ...acc, [field]: (details && details[field]) || "" }), {});

// ----- Reducer -----
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DISTRIBUTOR_DETAILS_LOADED:
      return {
        ...state,
        name: action.payload.name,
        details: withoutNulls(action.payload.details),
        areDetailsLoaded: true,
      };
    case DISTRIBUTOR_DETAILS_UPDATED:
      return {
        ...state,
        details: withoutNulls(action.payload.details),
      };
    default:
      return state;
  }
}

// ----- Actions -----
export const setDistributorDetails = ({ name, details }) => (dispatch) => {
  dispatch({
    type: DISTRIBUTOR_DETAILS_LOADED,
    payload: { name, details },
  });
};

export const updateDistributorDetails = (details) => (dispatch) => {
  dispatch({
    type: DISTRIBUTOR_DETAILS_UPDATED,
    payload: { details },
  });
};
